import ServerTime from './ServerTime';

export default ServerTime;